import { render, staticRenderFns } from "./SavingsCurrentAccount.vue?vue&type=template&id=5cbf3572&"
import script from "./SavingsCurrentAccount.vue?vue&type=script&lang=js&"
export * from "./SavingsCurrentAccount.vue?vue&type=script&lang=js&"
import style0 from "./SavingsCurrentAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports